import { useParams } from 'react-router-dom'
import { AxiosError } from 'axios'
import { Button, MenuItem } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import { useResultsInvalidation } from '@editorHooks'
import { resetPositionChecks } from '@mutations'
import { buildErrorMessage } from 'src/constants'

const ResetPositionChecks = () => {
  const { projectId } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const invalidateResults = useResultsInvalidation()

  const { mutateAsync: resetPositionChecksMutation } = useMutation(
    () => resetPositionChecks.request(projectId),
    {
      onSuccess: async () => {
        await invalidateResults(projectId as string)
        enqueueSnackbar('Ergebnisse wurden erfolgreich zurückgesetzt', { variant: 'success' })
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(buildErrorMessage(error, 'Fehler beim Zurücksetzen der Ergebnisse'), {
          variant: 'error',
        })
      },
    },
  )

  if (!projectId) {
    return null
  }

  return (
    <MenuItem>
      <Button
        onClick={() => resetPositionChecksMutation()}
        color="primary"
        variant="outlined"
        size="small"
        fullWidth
        data-cy="results-reset-button"
      >
        Ergebnisse zurücksetzen
      </Button>
    </MenuItem>
  )
}

export default ResetPositionChecks
